import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Modal,
  Col,
} from 'react-bootstrap';
import {
  FormControl,
  Button,
  DateTimePicker2 as DateTimePicker,
} from '../../../form/FormControls.jsx';
import Label from '@/component/form/Label.jsx';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import CounterpartyPicker from '../../../dict/simple/select/MultiDictsPicker.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import { List, Map } from 'immutable';
import Files from '../files/Files.jsx';
import { setDetachedPayment, updateDetachedPayment,
  tryToSaveDetachedPayment, tryToUpdateDetachedPayment }
  from '@/component/blogic/deals/store/deal.store.js';
import { filterExpense } from '@/component/blogic/deals/expenses/ExpensesElement.jsx';
import { storeFiles, resetFileStore } from '@/component/blogic/deals/store/files.store.js';
import {
  dateTimePickerFormat,
} from '../../../../util/util.jsx';
import {
  REF_PATH as INSURANCECOMPANY_REF_PATH,
}
  from '@/component/dict/simple/insurancecompany/Const';
import {
  REF_PATH as INSPECTIONCOMPANY_REF_PATH,
}
  from '@/component/dict/simple/inspectioncompany/Const';
import {
  REF_PATH as OWNER_REF_PATH,
}
  from '@/component/dict/simple/owner/Const';
import {
  REF_PATH as VESSEL_BROKER_REF_PATH,
}
  from '@/component/dict/simple/vesselbroker/Const';
import {
  REF_PATH as FORWARDER_REF_PATH,
}
  from '@/component/dict/simple/forwarder/Const';
import {
  REF_PATH as BUYER_REF_PATH,
}
  from '@/component/dict/simple/buyer/Const';
import {
  REF_PATH as SELLER_REF_PATH,
}
  from '@/component/dict/simple/supplier/Const';
import {
  REF_PATH as PRODUCER_TYPE_REF_PATH,
}
  from '@/component/dict/simple/producer/Const';
import { REF_PATH as TRADE_COUNTERPARTIES_REF_PATH }
  from '@/component/dict/simple/tradecounterparties/Const';
import { FREIGHT_EXPENSES_TYPE } from '@/component/blogic/deals/expenses/ExpensesUtils.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

class DetachedPaymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onSave = this.onSave.bind(this);
    this.storeFile = this.storeFile.bind(this);
    this.setSubmitDisabled = this.setSubmitDisabled.bind(this);
    this.onChangeSubpaymentDueAmount = this.onChangeSubpaymentDueAmount.bind(this);
    this.onChangeDueAmount = this.onChangeDueAmount.bind(this);
    this.validateSubpaymentDueAmount = this.validateSubpaymentDueAmount.bind(this);
    this.validateDueAmount = this.validateDueAmount.bind(this);
    this.setPayment = this.setPayment.bind(this);
    this.state = { component: null, init: false, submitActive: true };
  }


  componentWillReceiveProps(props) {
    let setPayment = false;
    let newValue = null;
    if (this.props.show != props.show) {
      if (props.show) {
        setPayment = true;
        this.state = { ...this.state, init: false, error: null };
      }
      if (!props.show) {
        this.props.resetPayment();
        this.state = { ...this.state, init: true };
      }
    }
    let parentId = props.parent && props.parent.get('id');
    if ((props.parent || props.parent === 0) && this.props.parent != props.parent) {
      props.handleUpdate('parent', parentId);
    }
    if (this.props.value != props.value) {
      parentId = (props.value && props.value.get('parent')) || parentId;
      newValue = props.value || new Map();
      newValue = newValue.size ? newValue.set('parent', parentId) : newValue;
      this.storeFile(props.value);
    }
    if (setPayment) {
      this.setPayment(newValue || new Map(), parentId);
    }
  }

  onSave() {
    const { data } = this.props;
    const formData = new FormData();
    formData.operationOfficer = this.props.currentUser;
    formData.id = data.get('id');
    formData.parent = data.get('parent');
    formData.contractNumber = data.get('contractNumber');
    formData.documentNumber = data.get('documentNumber');
    formData.expensesType = data.get('expensesType');
    formData.documentType = data.get('documentType');
    formData.counterparty = data.get('counterparty');
    formData.isDebit = data.get('isDebit');
    formData.dueAmountCurrency = data.get('dueAmountCurrency');
    formData.dueAmount = data.get('dueAmount');
    formData.dueDate = data.get('dueDate');
    formData.paymentAmount = data.get('paymentAmount');
    formData.paymentDate = data.get('paymentDate');
    formData.bank = data.get('bank');
    formData.notes = data.get('notes');
    formData.isDetached = true;
    if (data.get('profitabilitySubject') !== undefined) {
      formData.profitabilitySubject = data.get('profitabilitySubject');
    } else {
      formData.profitabilitySubject = this.props.payments.filter(p =>
        p.get('id') == data.get('parent')).map(f => f.get('profitabilitySubject')).get(0);
    }
    const multiPartformData = new FormData();
    this.appendFiles(multiPartformData);
    multiPartformData.append(
      'dto',

      new Blob([JSON.stringify(formData)], { type: 'application/json' })
    );
    if (data.get('id') || data.get('id') === 0) {
      this.props.tryToUpdate(data.get('id'), multiPartformData, this.closeModal);
    } else {
      this.props.tryToSave(multiPartformData, this.closeModal);
    }
  }

  onChangeSubpaymentDueAmount(e, v) {
    const value = parseFloat(v);
    this.validateSubpaymentDueAmount(value);
    this.props.handleUpdate('dueAmount', value);
  }

  onChangeDueAmount(e, v) {
    const value = parseFloat(v);
    this.validateDueAmount(value);
    this.props.handleUpdate('dueAmount', value);
  }

  setPayment(payment = new Map(), parentId = -1) {
    if (payment.get('isDebit') === undefined) {
      const parentPayment = this.props.payments
        .find(p => p.get('id') == parentId, this, new Map());
      return this.props.setPayment(
        payment.set('isDebit', parentPayment.get('isDebit', true)));
    }
    return this.props.setPayment(payment);
  }

  setSubmitDisabled(disable) {
    const node = document.getElementById('saveButton');
    if (node) {
      if (disable) {
        node.setAttribute('disabled', true);
      } else {
        node.removeAttribute('disabled');
      }
    }
  }

  getUUID(file) {
    const fileData = file.raw || file;
    if (fileData && fileData.meta && fileData.meta.uuid) {
      return fileData.meta.uuid;
    }
    if (fileData && fileData.file && fileData.file.preview) {
      const uuids = fileData.file.preview.split('/');
      return uuids[uuids.length - 1];
    }
    return undefined;
  }

  validateSubpaymentDueAmount(value) {
    const { data } = this.props;
    const parent = data.get('parent');
    if (parent || parent === 0) {
      const allPayments = this.props.payments;
      const parentPayment = allPayments.find(p => p.get('id') == parent, this, new Map());
      const totalDueAmountSum = parentPayment.get('payments', new List())
        .filter(p => p.get('id') != data.get('id'))
        .reduce((sum, p) => sum + p.get('dueAmount'), 0.00);
      if (totalDueAmountSum + parseFloat(value) > parentPayment.get('dueAmount')) {
        this.setState({ error:
          'Current subpayments due amount sum exceeds due amount value of the parent payment' });
        this.setSubmitDisabled(true);
        return false;
      }
    }
    this.setSubmitDisabled(false);
    this.setState({ error: null });
    return true;
  }

  validateDueAmount(value) {
    const { data } = this.props;
    const subpayments = data.get('payments', new List());
    if (subpayments.size) {
      const totalSubpaymentsDueAmount =
        subpayments.reduce((sum, p) => sum + parseFloat(p.get('dueAmount')), 0.00);
      if (totalSubpaymentsDueAmount > value) {
        this.setState({ error:
          'Current payment due amount is lower than subpayments due amount sum' });
        this.setSubmitDisabled(true);
        return false;
      }
    }
    this.setSubmitDisabled(false);
    this.setState({ error: null });
    return true;
  }

  appendFiles(formData) {
    this.appendFilesFromList(formData, 'USUAL');
  }

  appendFilesFromList(formData, partType) {
    let i;
    if (this.props.files.get(partType)) {
      const files = this.props.files.get(partType).toJS();
      for (i = 0; i < files.length; i++) {
        files[i].raw.meta.uuid = this.getUUID(files[i]);
        formData.append(`file_${partType}_${i}`, files[i].raw.file);
        formData.append(`file_${partType}_${i}_meta`,
          new Blob([JSON.stringify(files[i].raw.meta)],
            { type: 'application/json' },
          ));
      }
    }
  }

  closeModal() {
    this.props.onClose();
  }

  filterFunc(data) {
    return filterExpense(data, 'commonPayment');
  }

  storeFile(data) {
    if (!this.state.init && data && data.size && data.get('document')) {
      const paymentDocument = data.get('document');
      if (paymentDocument) {
        const originalFile = { file: {}, meta: paymentDocument.toJS() };
        this.props.storeFile(originalFile);
      }
    }
    this.setState({ init: true });
  }

  render() {
    const props = this.props;
    let data;
    if (props.data.size) {
      data = props.data;
    } else {
      data = props.value || new List();
    }

    const parentId = (props.parent || new Map()).get('id') || data.get('parent');

    let title;
    let currency = data.get('dueAmountCurrency');
    let isDebit = data.get('isDebit');
    if (parentId) {
      title = data.get('id') ? 'Edit subpayment' : 'Create subpayment';
      const parentPayment = this.props.payments
        .find(p => p.get('id') == parentId, this, new Map());
      currency = parentPayment.get('dueAmountCurrency') || 'USD';
      isDebit = parentPayment.get('isDebit');
    } else {
      title = data.get('id') ? 'Payment edit' : 'New payment';
    }
    if (!props.show) {
      return <div />;
    }
    const availableDicts = `${INSURANCECOMPANY_REF_PATH},${INSPECTIONCOMPANY_REF_PATH}
    ,${FORWARDER_REF_PATH},${VESSEL_BROKER_REF_PATH}, ${PRODUCER_TYPE_REF_PATH}
    ,${OWNER_REF_PATH},${BUYER_REF_PATH},${SELLER_REF_PATH},
     ${TRADE_COUNTERPARTIES_REF_PATH}`;
    const paymentFontSize = { fontSize: '13px' };
    const headerFontSize = { fontSize: '15px' };
    const buttonStyle = { width: '71px', height: '30px', padding: '2px 6px' };
    return !parentId ? (
      <Modal show={props.show} onHide={this.closeModal}>
        <Modal.Header style={{ padding: '5px' }}>
          <div style={{ ...headerFontSize, paddingLeft: '20px' }}>{title}</div>
        </Modal.Header>
        <Modal.Body style={{ ...paymentFontSize, paddingBottom: 0 }}>
          <Row>
            <Col md={6}>
              <Row>
                <Label
                  label="Document #" vertical sm={12}
                >
                  <FormControl
                    style={{ resize: 'none' }}
                    rows={1}
                    componentClass="textarea"
                    value={data.get('documentNumber')}
                    onChange={(e) => {
                      props.handleUpdate('documentNumber', e.target.value);
                    }}
                  />
                </Label>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Label
                  label="Due amount" vertical sm={12}

                >
                  <Col md={2} style={{ paddingLeft: '0px' }}>
                    <Button
                      id="isDebit"
                      bsStyle="primary"
                      style={{ width: '40px', height: '36px', padding: '0px' }}
                      onClick={() => props.handleUpdate('isDebit', !data.get('isDebit'))}
                    >
                      {data.get('isDebit')
                        ?
                        <div
                          style={{
                            fontSize: '200%',
                            top: '-8px',
                            position: 'relative',
                          }}
                        >
                          -
                        </div>
                        :
                        <div
                          style={{
                            fontSize: '200%',
                            top: '-5px',
                            position: 'relative',
                          }}
                        >
                          +
                        </div>
                      }
                    </Button>
                  </Col>
                  <Col md={2} style={{ padding: '0px' }}>
                    <CurrencyInput
                      noRates
                      defaultValue={data.get('dueAmountCurrency')}
                      name="dueAmountCurrency"
                      onChange={val => props.handleUpdate('dueAmountCurrency', val)}
                    />
                  </Col>
                  <Col md={8} style={{ paddingLeft: '2px', paddingRight: 0 }}>
                    <FancyInput
                      className="form-control"
                      fraction={2}
                      positive
                      negative={false}
                      thousand
                      type="number"
                      value={data.get('dueAmount')}
                      onChange={this.onChangeDueAmount}
                    />
                  </Col>
                </Label>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={12} style={{ padding: '0 20px 10px', textAlign: 'center' }}>
              <span style={{ color: 'red', textAlign: 'center' }}>{this.state.error}</span>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Label
                  label="Document type" vertical sm={12}

                >
                  <RefPicker
                    dict="documenttype"
                    name={'documenttype'}
                    updateDefValueOnEveryChange
                    defaultValue={data.get('documentType')}
                    onChangeFunc={v => {
                      const value = v ? v.value : null;
                      props.handleUpdate('documentType', value);
                    }}
                  />
                </Label>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Label
                  label="Due Date" vertical sm={12}
                >
                  <DateTimePicker
                    time={false}
                    disabled={data.get('payments', new List()).size > 0}
                    format={dateTimePickerFormat}
                    defaultValue={data.get('dueDate') ?
                      new Date(data.get('dueDate')) : undefined}
                    onChange={val => {
                      props.handleUpdate('dueDate', val ?
                        moment(val).format(dateTimePickerFormat) : undefined);
                    }}
                  />
                </Label>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Label
                  label="Type" vertical sm={12}

                >
                  <RefPicker
                    dict="expensestype"
                    name={'expensestype'}
                    filterFunc={this.filterFunc}
                    updateDefValueOnEveryChange
                    excludeDataNames={[FREIGHT_EXPENSES_TYPE]}
                    defaultValue={data.get('expensesType')}
                    onChangeFunc={v => {
                      const value = v ? v.value : null;
                      props.handleUpdate('expensesType', value);
                    }}
                  />
                </Label>
              </Row>
            </Col>
            <Col xs={6}>
              <Row>
                <Label label="Bank" vertical sm={12}>
                  <RefPicker
                    dict="bank" name="bank"
                    updateDefValueOnEveryChange
                    defaultValue={data.get('bank')}
                    onChangeFunc={v => {
                      const value = v ? v.value : null;
                      props.handleUpdate('bank', value);
                    }}
                  />
                </Label>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Row>
                <Label
                  label="Counterparty" vertical sm={12}

                >
                  <CounterpartyPicker
                    dicts={availableDicts}
                    name="counterparty"
                    addButtonDict={data.get('expensesType') || data.get('expensesType') === 0 ?
                      TRADE_COUNTERPARTIES_REF_PATH : undefined}
                    onBeforeAddDictValue={(refDto) =>
                      ({ ...refDto, expensesType: data.get('expensesType') })}
                    defaultValue={data.get('counterparty')}
                    onChangeFunc={v => {
                      const value = v ? v.value : null;
                      props.handleUpdate('counterparty', value);
                    }}
                  />
                </Label>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Label label="Notes" vertical sm={12}>
                  <FormControl
                    style={{ resize: 'none' }}
                    componentClass="textarea"
                    rows={1}
                    value={data.get('notes')}
                    onChange={e => props.handleUpdate('notes', e.target.value)}
                  />
                </Label>
              </Row>
            </Col>
          </Row>
          <Row style={{ marginTop: 9 }}>
            <Col md={6} >
              <Row>
                <Label
                  label="Allocate to all deals"
                  sm={7} horizontal
                  style={{ paddingRight: 0, display: 'flex', alignItems: 'center' }}
                  childStyle={{ paddingLeft: 0 }}
                >
                  <Button
                    className={'button-pair-left'}
                    bsStyle={data.get('profitabilitySubject') && 'primary'}
                    onClick={() => props.handleUpdate('profitabilitySubject', true)}
                  >Yes</Button>
                  <Button
                    className={'button-pair-right'}
                    bsStyle={data.get('profitabilitySubject') === false && 'primary'}
                    onClick={() => props.handleUpdate('profitabilitySubject', false)}
                  >No</Button>
                </Label>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={12} style={{ paddingTop: '8px' }}>
              <Files
                label="Invoice"
                labelStyle={paymentFontSize}
                type="USUAL"
                dealType="payment"
                noModal
                singleMode
                onEditModeSwitch={this.setSubmitDisabled}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer style={{ padding: '10px' }}>
          <Button onClick={this.closeModal} style={buttonStyle}>Cancel</Button>
          <Button
            id="saveButton"
            style={buttonStyle}
            bsStyle="primary"
            onClick={this.onSave}
          >Save</Button>
        </Modal.Footer>
      </Modal>
    ) : (
      <Modal show={props.show} onHide={this.closeModal}>
        <Modal.Header style={{ padding: '5px' }}>
          <div style={{ ...headerFontSize, paddingLeft: '20px' }}>{title}</div>
        </Modal.Header>
        <Modal.Body style={{ ...paymentFontSize, paddingBottom: 0 }}>
          <Row style={paymentFontSize}>
            <Col md={12}>
              <Row>
                <Col md={6}>
                  <Row>
                    <Label
                      label="Due amount" vertical sm={12}
                    >
                      <Col md={2} style={{ paddingLeft: '0px' }}>
                        <Button
                          id="isDebit"
                          bsStyle="primary"
                          disabled
                          style={{ width: '40px', height: '36px', padding: '0px' }}
                        >
                          {isDebit
                            ?
                            <div
                              style={{
                                fontSize: '200%',
                                top: '-8px',
                                position: 'relative',
                              }}
                            >
                            -
                            </div>
                            :
                            <div
                              style={{
                                fontSize: '200%',
                                top: '-5px',
                                position: 'relative',
                              }}
                            >
                            +
                            </div>
                          }
                        </Button>
                      </Col>
                      <Col md={2} style={{ padding: '0px' }}>
                        <CurrencyInput
                          noRates
                          disabled
                          defaultValue={currency}
                          name="dueAmountCurrency"
                        />
                      </Col>
                      <Col md={8} style={{ paddingLeft: '2px', paddingRight: 0 }}>
                        <FancyInput
                          className="form-control"
                          fraction={2}
                          positive
                          negative={false}
                          thousand
                          type="number"
                          value={data.get('dueAmount')}
                          onChange={this.onChangeSubpaymentDueAmount}
                        />
                      </Col>
                    </Label>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Label
                      label="Due Date" vertical sm={12}
                    >
                      <DateTimePicker
                        time={false}
                        format={dateTimePickerFormat}
                        defaultValue={data.get('dueDate') ?
                          new Date(data.get('dueDate')) : undefined}
                        onChange={val => {
                          props.handleUpdate('dueDate', val ?
                            moment(val).format(dateTimePickerFormat) : undefined);
                        }}
                      />
                    </Label>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={12} style={{ padding: '0 20px' }}>
                  <span style={{ color: 'red', textAlign: 'center' }}>{this.state.error}</span>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <Row>
                    <Label label="Bank" vertical sm={12}>
                      <RefPicker
                        dict="bank" name="bank"
                        updateDefValueOnEveryChange
                        defaultValue={data.get('bank')}
                        onChangeFunc={v => {
                          const value = v ? v.value : null;
                          props.handleUpdate('bank', value);
                        }}
                      />
                    </Label>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Row>
                    <Label label="Notes" vertical sm={12}>
                      <FormControl
                        style={{ resize: 'none' }}
                        componentClass="textarea"
                        rows={1}
                        value={data.get('notes')}
                        onChange={e => props.handleUpdate('notes', e.target.value)}
                      />
                    </Label>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col
                  xs={12}
                  style={{ paddingTop: '8px' }}
                >
                  <Files
                    label="Invoice"
                    labelStyle={paymentFontSize}
                    type="USUAL"
                    dealType="payment"
                    noModal
                    singleMode
                    onEditModeSwitch={this.setSubmitDisabled}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer style={{ padding: '10px' }}>
          <Button onClick={this.closeModal} style={buttonStyle}>Cancel</Button>
          <Button
            id="saveButton"
            style={buttonStyle}
            bsStyle="primary"
            onClick={this.onSave}
          >Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DetachedPaymentForm.propTypes = {
  currentUser: React.PropTypes.number,
  data: React.PropTypes.object,
  handleUpdate: React.PropTypes.func,
  setPayment: React.PropTypes.func,
  resetPayment: React.PropTypes.func,
  storeFile: React.PropTypes.func,
  files: React.PropTypes.object,
  tryToSave: React.PropTypes.func,
  tryToUpdate: React.PropTypes.func,
  onClose: React.PropTypes.func,
  show: React.PropTypes.bool,
  value: React.PropTypes.object,
  parent: React.PropTypes.object,
  payments: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.object]),
};

export default connect(
  (state) => ({
    data: state.getIn(['data', 'deals', 'deal', 'payment'], new Map()),
    currentUser: Number(state.getIn(['session', 'id'])),
    files: state.getIn(['data', 'deals', 'files']),
    payments: state.getIn(['data', 'deals', 'deal', 'payments'], new List()),
  }),
  (dispatch) => ({
    setPayment(payment) {
      setDetachedPayment(dispatch, payment);
    },
    resetPayment() {
      setDetachedPayment(dispatch, null);
      resetFileStore(dispatch, 'USUAL');
    },
    handleUpdate(prop, value) {
      updateDetachedPayment(dispatch, prop, value);
    },
    tryToSave(data, callback) {
      tryToSaveDetachedPayment(dispatch, data, callback);
    },
    tryToUpdate(id, data, callback) {
      tryToUpdateDetachedPayment(dispatch, id, data, callback);
    },
    storeFile(file) {
      storeFiles(dispatch, List.of(file), 'USUAL');
    },
  }),
)(DetachedPaymentForm);
